import { useMutation } from '@tanstack/react-query';
import ContractTemplateService from '@clickersphere/core/services/ContractTemplateService';

export function useAnalyzeContractTemplate() {
  const {
    isPending: analyzeContractTemplateIsPending,
    mutateAsync: analyzeContractTemplateAsync,
    reset: resetAnalyzeContractTemplate,
  } = useMutation({
    mutationFn: async (fileKey: string) =>
      ContractTemplateService.analyze(fileKey),
  });

  return {
    analyzeContractTemplateAsync,
    analyzeContractTemplateIsPending,
    resetAnalyzeContractTemplate,
  };
}
